import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { MediaPromoItemSchema } from "../../fragments/MediaPromoItem";
import { generateContentGroupSchema } from "../../utils/helpers";
const GroupedMediaPromoItemSchema = generateContentGroupSchema(MediaPromoItemSchema);
export const GroupedMediaPromosBladeTypeValues = [
    "articleMediaCarousel",
    "chooseFighter",
    "landingMediaCarousel",
    "iconTab",
];
export const GroupedMediaPromosBladeTypesSchema = z.enum(GroupedMediaPromosBladeTypeValues);
export const GroupedMediaPromosBladeTypes = GroupedMediaPromosBladeTypesSchema.enum;
export const GroupedMediaPromosBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    groups: z.array(GroupedMediaPromoItemSchema).nonempty(),
});
export const GroupedMediaPromosBladesContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: GroupedMediaPromosBladeTypesSchema,
});
export const ArticleMediaCarouselContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: z.literal(GroupedMediaPromosBladeTypes.articleMediaCarousel),
});
export const ChooseFighterContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: z.literal(GroupedMediaPromosBladeTypes.chooseFighter),
});
export const LandingMediaCarouselContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: z.literal(GroupedMediaPromosBladeTypes.landingMediaCarousel),
});
export const IconTabContractSchema = GroupedMediaPromosBladeSchema.extend({
    type: z.literal(GroupedMediaPromosBladeTypes.iconTab),
});
//# sourceMappingURL=index.js.map